import React from "react";

function Whatsapp() {
  return (
    <a href="https://wa.me/917338658118" target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp" className="s-whatsapp">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
      >
        <path
          d="M24.08 3.99999C13.16 3.99999 4.25998 12.9 4.25998 23.82C4.25998 27.32 5.17998 30.72 6.89998 33.72L4.09998 44L14.6 41.24C17.5 42.82 20.76 43.66 24.08 43.66C35 43.66 43.9 34.76 43.9 23.84C43.9 18.54 41.84 13.56 38.1 9.81999C36.2661 7.9682 34.082 6.49992 31.675 5.50071C29.268 4.5015 26.6861 3.99135 24.08 3.99999ZM24.1 7.33999C28.5 7.33999 32.62 9.05999 35.74 12.18C37.2707 13.711 38.4844 15.529 39.3115 17.5298C40.1386 19.5306 40.5629 21.675 40.56 23.84C40.56 32.92 33.16 40.3 24.08 40.3C21.12 40.3 18.22 39.52 15.7 38L15.1 37.66L8.85998 39.3L10.52 33.22L10.12 32.58C8.46907 29.9568 7.59531 26.9194 7.59998 23.82C7.61998 14.74 15 7.33999 24.1 7.33999ZM17.06 14.66C16.74 14.66 16.2 14.78 15.74 15.28C15.3 15.78 14 17 14 19.42C14 21.86 15.78 24.2 16 24.54C16.28 24.88 19.52 29.88 24.5 32C25.68 32.54 26.6 32.84 27.32 33.06C28.5 33.44 29.58 33.38 30.44 33.26C31.4 33.12 33.36 32.06 33.78 30.9C34.2 29.74 34.2 28.76 34.08 28.54C33.94 28.34 33.62 28.22 33.12 28C32.62 27.72 30.18 26.52 29.74 26.36C29.28 26.2 29 26.12 28.62 26.6C28.3 27.1 27.34 28.22 27.06 28.54C26.76 28.88 26.48 28.92 26 28.68C25.48 28.42 23.88 27.9 22 26.22C20.52 24.9 19.54 23.28 19.24 22.78C19 22.3 19.22 22 19.46 21.78C19.68 21.56 20 21.2 20.2 20.9C20.46 20.62 20.54 20.4 20.7 20.08C20.86 19.74 20.78 19.46 20.66 19.22C20.54 19 19.54 16.52 19.12 15.54C18.72 14.58 18.32 14.7 18 14.68C17.72 14.68 17.4 14.66 17.06 14.66Z"
          fill="#F3F3F3"
        />
      </svg>
    </a>
  );
}

export default Whatsapp;
